/**
 *Created by jmmartinez on 18/03/19
 * v.1.1  22/03/2019 Añadido PDF EXCEL
 * v.1.2  24/04/2019 Eliminado Container y añadido Divs con css
 * v.1.3  26/09/2019 Disabled botón Modificar y Eliminar según el elementoSeleccionado que entra en props.
 * v.1.4  01/10/2019 Nueva propiedad botonesAdicionales y su gestión.
 *                   Nuevo evento onBotonAdicionalClick
 * v.1.5  28/10/2019 Añadido elementoSeleccionado al state en el constructor y controlado en WillReceive
 * v.1.6  02/06/2020 Añadida propiedad en botón mostrarSinElementos, para que aparezca el boton adicional aunq no haya elementos.
 *                   Modificado comportamiento para no ocultar ni desactivar los que tengan mostrarSinElementos.
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  19/04/2021 Añadimos la propiedad mostrarGridConfigurar.
 *                   Modificamos render para sólo pintar el botón de Configurar si existe la propiedad mostrarGridConfigurar
 *
 * v.2.2  06/05/2022 Fusion Sidemur y Planifikator
 * v.2.3  ANULADO!!!! 21/06/2022 Añadida condición  "&& !botonesAdicionales" a render de botones
 * */

import React from 'react'
import PropTypes from 'prop-types';
import {Button} from "@blueprintjs/core";
import '../../resources/css/formulariobotonera.css';
import {MODO_MOSTRARDATOS_GRID, MODO_MOSTRARDATOS_TABLA} from "./FormularioGrid";



export const BOTONERA_ACCION_NODEFINIDO = 0;
export const BOTONERA_ACCION_NUEVO= 'NUEVO';
export const BOTONERA_ACCION_ELIMINAR = 'ELIMINAR';
export const BOTONERA_ACCION_ELIMINARDESDEGRID = 'ELIMINAR_DESDEGRID';
export const BOTONERA_ACCION_MODIFICAR = 'MODIFICAR';
export const BOTONERA_ACCION_PDF = 'PDF';
export const BOTONERA_ACCION_EXCEL = 'EXCEL';
export const BOTONERA_ACCION_REFRESCAR= 'REFRESCAR';


export const BOTONERA_NUEVO= 'NUEVO';
export const BOTONERA_ELIMINAR = 'ELIMINAR';
export const BOTONERA_ELIMINARDESDEGRID = 'ELIMINAR_DESDEGRID';
export const BOTONERA_MODIFICAR = 'MODIFICAR';
export const BOTONERA_PDF = 'PDF';
export const BOTONERA_EXCEL = 'EXCEL';
export const BOTONERA_REFRESCAR= 'REFRESCAR';



class FormularioBotonera extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            numElementos: props.numElementos,
            showAcciones: props.showAcciones ? props.showAcciones : [],
            elementoSeleccionado: props.elementoSeleccionado,
        }
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if(nextProps.elementoSeleccionado !== prevState.elementoSeleccionado){
            newState.elementoSeleccionado= nextProps.elementoSeleccionado;
        }

        if(nextProps.numElementos !== prevState.numElementos){
            newState.numElementos= nextProps.numElementos;
        }


        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    onAccion= (accion) => {
        const {onAccion} = this.props;
        onAccion && onAccion(accion);
    }

    onBotonAdicionalClick= (boton) => {
        const {onBotonAdicionalClick} = this.props;
        onBotonAdicionalClick && onBotonAdicionalClick(boton);
    }

    onGridConfigurarClick = () => {
        const {onGridConfigurarClick} = this.props;
        onGridConfigurarClick && onGridConfigurarClick();
    }

    onConmutarModoMostrar = (newModo) => {
        const {onConmutarModoMostrarDatos} = this. props;
        onConmutarModoMostrarDatos && onConmutarModoMostrarDatos(newModo);
    }

    render() {
        const {numElementos, showAcciones, elementoSeleccionado} =  this.state;
        const {botonesAdicionales,
            mostrarConmutadorModoMostrarDatos, modoMostrarDatos, onConmutarModoMostrarDatos,
            mostrarGridConfigurar} = this.props;
        let activoElemento=  elementoSeleccionado !== null;

        //console.log("FORMULARIOBOTONERA - RENDER");
        //console.log("elementoSeleccionado: ", elementoSeleccionado);
        //console.log("botonesAdicionales: ", botonesAdicionales);
        //console.log("mostrarConmutadorModoMostrarDatos: ", mostrarConmutadorModoMostrarDatos);

        return (
            <div className="botonera">
                {( (showAcciones.length === 0 ) || showAcciones.includes(BOTONERA_NUEVO)) &&
                <Button icon="document" className="boton"  onClick={() => this.onAccion(BOTONERA_ACCION_NUEVO)}>Nuevo</Button>
                }
                {( (showAcciones.length === 0 ) ||showAcciones.includes(BOTONERA_MODIFICAR)) && numElementos > 0 &&
                <Button icon="edit" className="boton" disabled={!activoElemento} onClick={() => this.onAccion(BOTONERA_ACCION_MODIFICAR)}>Modificar</Button>
                }
                {( (showAcciones.length === 0 ) ||showAcciones.includes(BOTONERA_ELIMINAR)) && numElementos > 0 &&
                <Button icon="trash" className="boton" disabled={!activoElemento} onClick={() => this.onAccion(BOTONERA_ACCION_ELIMINAR)}>Eliminar</Button>
                }
                {( (showAcciones.length === 0 ) ||showAcciones.includes(BOTONERA_PDF)) && numElementos > 0 &&
                <Button icon="print" className="boton" onClick={() => this.onAccion(BOTONERA_ACCION_PDF)}>PDF</Button>
                }
                {( (showAcciones.length === 0 ) ||showAcciones.includes(BOTONERA_EXCEL)) && numElementos > 0 &&
                <Button icon="th" className="boton" onClick={() => this.onAccion(BOTONERA_ACCION_EXCEL)}>Excel</Button>
                }
                {( (showAcciones.length === 0 ) ||showAcciones.includes(BOTONERA_REFRESCAR)) &&
                <Button icon="refresh" className="boton" onClick={() => this.onAccion(BOTONERA_ACCION_REFRESCAR)}>Refrescar</Button>
                }

                {
                    botonesAdicionales &&
                    botonesAdicionales.map((boton, index) => {
                        //console.log("boton adicional: ", boton);
                        let disabled= !activoElemento && !boton.mostrarSinElementos;
                        //console.log("disabled: ", disabled);
                        if (numElementos > 0  || boton.mostrarSinElementos)
                            return <Button key={index} icon={boton.icon} disabled={disabled} className="boton"
                                       onClick={() => this.onBotonAdicionalClick(boton)}>{boton.titulo}</Button>
                    })
                }

                {mostrarGridConfigurar &&
                <Button icon="git-push" small={true} minimal={true} onClick={this.onGridConfigurarClick}/>
                }
                {(mostrarConmutadorModoMostrarDatos && modoMostrarDatos == MODO_MOSTRARDATOS_TABLA) &&
                <Button icon="th-list" small={true} minimal={true} onClick={() => this.onConmutarModoMostrar(MODO_MOSTRARDATOS_GRID)}/>
                }
                {(mostrarConmutadorModoMostrarDatos && modoMostrarDatos == MODO_MOSTRARDATOS_GRID) &&
                <Button icon="heat-grid" small={true} minimal={true} onClick={() => this.onConmutarModoMostrar(MODO_MOSTRARDATOS_TABLA)}/>
                }
            </div>
        );
    }
}

FormularioBotonera.propTypes = {
    numElementos: PropTypes.number.isRequired,
    showAcciones: PropTypes.array,
    elementosSeleccionado: PropTypes.object,
    botonesAdicionales: PropTypes.array,
    onBotonAdicionalClick: PropTypes.func,
    onGridConfigurarClick: PropTypes.func,

    mostrarConmutadorModoMostrarDatos: PropTypes.bool,
    modoMostrarDatos: PropTypes.number,
    onConmutarModoMostrarDatos: PropTypes.func,
    mostrarGridConfigurar: PropTypes.bool,
}

export default FormularioBotonera
